import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import shuffle from 'lodash/shuffle';
import isEmpty from 'lodash/isEmpty';

import { getFanFavourites } from 'Api/Reviews/user-review-service';
import FanFavouritesCarousel from 'Components/Carousel/FanFavouritesCarousel/FanFavouritesCarousel';
import BrowseButton from 'Components/Utility/BrowseButton';

const FanFavouritesSection = ({ newReleases }) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const query = { hitsPerPage: 10, newReleases, onSale: true };

      if (newReleases) query.onSale = false;

      const results = await getFanFavourites({ hitsPerPage: 10, onSale: true, newReleases });
      setHits(results);
      setHasLoaded(true);
    };

    if (!hasLoaded) fetchData();
  }, [hasLoaded, newReleases]);

  if (hasLoaded && isEmpty(hits)) return false;

  return (
    <section className="fan-favourites container">
      <div className="section-heading-container">
        <h2 className="section-title">
          <FormattedMessage
            id="community.fanaticalgamersrecommend"
            defaultMessage="Fanatical Gamers Recommend"
          />
        </h2>
        <BrowseButton className={'view-all-btn'} location="recommended" />
      </div>
      {hits &&
        <FanFavouritesCarousel hitData={shuffle(hits)} />
      }
    </section>
  );
};

FanFavouritesSection.propTypes = {
  newReleases: PropTypes.bool,
};

FanFavouritesSection.defaultProps = {
  newReleases: false,
};

export default FanFavouritesSection;
